import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormRefresh = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormRefresh' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M17.3333333,9.33333333 C16.3982691,7.36020781 14.3579813,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 M18.5,6 L18.5,10 L14.5,10' />
  </StyledIcon>
);
